const DamFolderTypes = {
  FETCH_DATA_SUCCESS: 'FETCH_DATA_SUCCESS',
  GET_FOLDER_DETAIL: 'GET_FOLDER_DETAIL',
  UNMOUNT_FOLDER_DATA: 'UNMOUNT_FOLDER_DATA',
  FETCH_FILES_SUGGESTION: 'FETCH_FILES_SUGGESTION',
  SET_FOLDER_FILTER_SORT_DATA: 'SET_FOLDER_FILTER_SORT_DATA',
  SET_ARCHIVED_FOLDERS: 'SET_ARCHIVED_FOLDERS',
  SET_DELETED_FOLDERS: 'SET_DELETED_FOLDERS',
  CLEAR_FOLDER_LIST: 'CLEAR_FOLDER_LIST',
};

export default DamFolderTypes;
